module.exports = require("./../../_gen/starling/animation/DelayedCall");